export enum TradeOrgPages {
  NBF = "nbf",
  Norboat = "norboat",
  NCB = "ncb",
  NMCF = "nmcf",
  MobilityPool = "mobilitypool",
  Bruktbilgruppen = "bruktbilgruppen",
  Smabatregisteret = "smabatregisteret",
  MRF = "mrf",
  Sweboat = "sweboat",
  NBAS = "nbas",
}
